type CancelDeflectionVariant = {
  promoCode: string;
  modal?: string;
};

const S12NV0 = 's12';
const CPLUSV1 = 'cplusV1';
const CPLUSV2 = 'cplusV2';

const cancelDeflectionVariants: CancelDeflectionVariant[] = [
  { promoCode: 'SUBS_DISCOUNT_25', modal: S12NV0 },
  { promoCode: 'SUBS_DISCOUNT_50', modal: S12NV0 },
  { promoCode: 'SUBS_FREETOPAID_DISCOUNT_25', modal: S12NV0 },
  { promoCode: 'SUBS_FREETOPAID_DISCOUNT_50', modal: S12NV0 },
  { promoCode: 'CPLUS_CANCELDEFLECT_50', modal: CPLUSV1 },
  { promoCode: 'CPLUS_CANCELDEFLECT_25', modal: CPLUSV1 },
  { promoCode: 'CPLUS_CANCELDEFLECT_100', modal: CPLUSV2 },
];

export const isValidPromoCode = (code: string | undefined): boolean => {
  return cancelDeflectionVariants.some((v) => v.promoCode === code);
};

export const isS12V0PromoCode = (code: string): boolean => {
  const entry: CancelDeflectionVariant | undefined = cancelDeflectionVariants.find((v) => v.promoCode === code);
  if (!entry) {
    return false;
  }
  return entry.modal === S12NV0;
};

export const isCplusV1PromoCode = (code: string): boolean => {
  const entry: CancelDeflectionVariant | undefined = cancelDeflectionVariants.find((v) => v.promoCode === code);
  if (!entry) {
    return false;
  }
  return entry.modal === CPLUSV1;
};

export const isCplusPromoCode = (code: string): boolean => {
  const entry: CancelDeflectionVariant | undefined = cancelDeflectionVariants.find((v) => v.promoCode === code);
  if (!entry) {
    return false;
  }
  return entry.modal === CPLUSV1 || entry.modal === CPLUSV2;
};

export const isCplusAnnualPromoCode = (code: string): boolean => {
  return code === 'CPLUS_CANCELDEFLECT_25';
};
